export default defineNuxtRouteMiddleware((to) => {
  // Only process if 'filter' parameter exists in query
  if (!to.query.filter) {
    return
  }

  // Find all query parameters that contain ':' in their name or value format
  const filterParams: string[] = []
  const cleanQuery: Record<string, any> = {}

  // Get the existing filter value
  let filterValue = to.query.filter as string

  for (const [key, value] of Object.entries(to.query)) {
    // Skip the main filter parameter
    if (key === 'filter') {
      cleanQuery[key] = value
      continue
    }

    // Check if the key contains ':' (these are filter parameters to merge)
    if (key.includes(':')) {
      // If the key has a colon, it's a filter parameter to be merged
      // Just use the key itself (e.g., 'fmod_46:746,747' or 'price0:2')
      filterParams.push(key)
    } else {
      // Keep other parameters as-is (like 'page', 'sort', etc.)
      cleanQuery[key] = value
    }
  }

  // If we found filter parameters to merge
  if (filterParams.length > 0) {
    // Append them to the filter parameter with '|' separator
    const additionalFilters = filterParams.join('|')
    filterValue = `${filterValue}|${additionalFilters}`

    // Update the query
    cleanQuery.filter = filterValue

    // Redirect to the cleaned URL
    return navigateTo({
      path: to.path,
      query: cleanQuery
    }, { replace: true })
  }
})